<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
<template>
  <v-content> 
    <div class="block">
    <v-container>
      <v-row>
        <v-col v-for="item in items" :key="item.id" cols="12" md="6">
          <v-card dark class="mx-auto" max-width="320" min-height="520" max-height="700" style="background-color:#25262D">
            <router-link style="color:white" :to="{path:item.router}">
            <v-img
              class="white--text align-end"
              height="370px"
              :src="item.src"
            >
              
            </v-img>
            <v-card-title style="background-color: transparent; font-weight: 600;">{{ item.title }}</v-card-title>
            <v-card-text style="font-weight: 200;">
              <div>{{ item.description }}</div>
            </v-card-text>
            </router-link>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
  </v-content>
</template>

<script>

export default {
  name: "IiotGarbage",
  data() {
    return {	
      items: [
      {
        id: 1,
        title: "TRUCKS",
        description: "Truck management UI.",
        router: "/scenarios/iiot/trucks",
        src: require("../../../assets/scenarios/garbage/truck.png")
      },
      {
        id: 2,
        title: "CONTAINERS",

        description: "Containers management UI.",
        router: "/scenarios/iiot/containers/map",
        src: require("../../../assets/scenarios/garbage/container.png")
      },
      ]
    };
  }
};
</script>